import React from 'react'

import styles from './steps.module.scss'

export default function Steps() {
  return (
    <div className={styles.container}>
      <div className={styles.iconheart} />
      <h2>What are the steps of puppy travel?</h2>
      <ul className={styles.grid}>
        <div className={styles.step1}>
          <li>
            <div className={styles.icon1} />
            Reserve your Puppy
          </li>
          <p>
            Once you’ve fallen head over heels for one special puppy, click
            “Reserve this Puppy” to let us know! Fill in your details and pay a
            deposit to make sure no one else can buy them.
          </p>
        </div>
        <div className={styles.step2}>
          <li>
            <div className={styles.icon2} />
            Coordinate Travel
          </li>
          <p>
            Our team will coordinate with the breeder the travel or pickup
            arrangements. Sometimes breeders have their own provider - if not we
            will coordinate with one of our trusted travel providers.{' '}
          </p>
        </div>
        <div className={styles.step3}>
          <li>
            {' '}
            <div className={styles.icon3} />
            Puppy Pickup
          </li>
          <p>
            The travel provider will pickup the pup from the breeder and begin
            it’s journey to your home.{' '}
          </p>
        </div>
        <div className={styles.step4}>
          <li>
            {' '}
            <div className={styles.icon4} />
            Communication
          </li>
          <p>
            The transporter will contact you with an estimated time of arrival
            once they are on the road.
          </p>
        </div>
        <div className={styles.step5}>
          <li>
            {' '}
            <div className={styles.icon5} />
            Puppy Delivery
          </li>
          <p>
            Your puppy will be delivered safely to your door, to your nearest
            airport or to a specific meet up location! We love seeing our
            puppies in their new loving homes!
          </p>
        </div>
      </ul>
    </div>
  )
}
